import React from 'react'
import { DEMO } from '../api/settings'

const etaps: { [key: string]: any[] } = {
  'E2': [{
    num: 1,
    link: 'zadost-o-stanoveni-vyse-a-podminek-uhrady',
    dbid: 'ef1a2bd0-9998-4fdb-80c9-ed74b36493a0',
    info: 'LP - single + single (s kodem, podobnym)'
  }, {
    num: 2,
    link: 'zadost-o-stanoveni-maximalni-ceny',
    dbid: '3a525a03-64dc-4abd-a900-da3668d3b0d8',
    info: 'LP - single (s kodem, zruseno)'

  }, {
    num: 3,
    link: 'zadost-o-stanoveni-maximalni-ceny-vyrobce-a-vyse-podminek-uhrady',
    dbid: 'f06fd956-03f6-4e81-bce1-a21dd4e8754c',
    info: 'LP - single + single (s kodem, podobnym)'
  }, {
    num: 4,
    link: 'zadost-o-zmenu-vyse-a-podminek-uhrady',
    dbid: 'd1eca023-bb57-431a-83f8-3504c52245f1',
    info: 'LP - single'
  }, {
    num: 5,
    link: 'zadost-o-zmenu-maximalni-ceny-vyrobce',
    dbid: '1cd04100-5670-42d8-b2fe-2f6d318d2f46',
    info: 'LP - single (s kodem)'
  }, {
    num: 6,
    link: 'zadost-o-zmenu-maximalni-ceny-vyrobce-a-vyse-uhrady',
    dbid: '58fe90e0-9c72-4140-8c49-6810f23d7fb7',
    info: 'LP - single'
  }, {
    num: 8,
    link: 'zadost-o-zruseni-maximalni-ceny',
    dbid: 'c8b19e77-c779-4748-99fd-1655bbdfef3a',
    info: 'LP - single'
  }, {
    num: 9,
    link: 'zadost-o-kvalifikaci-do-uhradove-souteze',
    dbid: '5b7178df-69a9-4513-a944-03345c220c95',
    info: 'LP - array '
  }, {
    num: 10,
    link: 'zadost-o-provedeni-zkracene-revize-systemu-uhrad',
    dbid: '68e302b8-9a35-4809-a92a-e9c78cc337b7',
    info: 'LP - array + array '
  }, {
    num: 11,
    link: 'zadost-o-prepis-maximalni-ceny-vyrobce-vyse-a-podminek-uhrady',
    dbid: 'cf3ec31b-5627-4e68-82e3-38bbdae00c1c',
    info: 'LP - array two col'
  }, {
    num: 12,
    link: 'hlaseni-ceny-puvodce',
    dbid: 'b663f875-fe8f-44be-b8f2-88cda31aa409',
    info: 'LP - array (13252, 0029463)'
  }, {
    num: 13,
    link: 'oznameni-o-zahajeni-preruseni-ukonceni-zasilkoveho-vydeje',
    dbid: 'c544cf3b-3c79-4cfe-90de-b59b029bde37'
  }, {
    num: 14,
    link: 'hlaseni-o-zahajeni-preruseni-obnoveni-a-ukonceni-uvadeni-leciveho-pripravku-na-trh',
    dbid: 'e4bd23d6-da33-4ed6-a710-75d20aea781a',
    info: 'LP - single'
  }, {
    num: 16,
    link: 'hlaseni-nps-ukonceni',
    dbid: '02b58aef-eee2-4967-a979-b7e76a99b12f',
    link2: '/form/hlaseni-nps-ukonceni?prev=kUQFOXzCNNtMJLt3nRNrgWbJjFOyUBmp',
  }, {
    num: 17,
    link: 'oznameni-o-pouziti-nlp',
    dbid: '184baee4-2fa1-4485-8d4e-8ffb2d4ad182'
  }, {
    num: 19,
    link: 'hlaseni-nps-uvodni',
    dbid: 'bf8d231d-4a79-48f5-ae00-d3b69a6cf2de',
    link2: '/submission/kUQFOXzCNNtMJLt3nRNrgWbJjFOyUBmp',
    info: 'LP - array'
  }, {
    num: 21,
    link: 'specificky-lecebny-program',
    dbid: '6568f722-6bd1-4e9d-ba50-36db075715e3'
  }, {
    num: 26,
    link: 'zadost-o-poskytnuti-informace',
    dbid: 'c8ae7e09-e50a-4143-8589-0d6659de5fe0'
  },
    {
      num: '24 (25)',
      link: 'zadost-o-vypracovani-odborneho-stanoviska',
      dbid: 'ff424e9c-be51-403d-a80b-a92d8fc3f327'
    }],
  'E3': [
    {
      num: '27.1',
      link: 'platby-nahrady-vydaju-zdravotnicke-prostredky',
      name: 'Náhrady zdravotnických prostředků - Zdravotnické prostředky a diagnostické zdravotnické prostředky in vitro',
      info: 'default - 17 - isSpec - noLP - noMin'
    },
    {
      num: '27.2',
      link: 'platby-nahrady-vydaju-registrace',
      name: 'Náhrady výdajů - Registrace',
      info: 'default - 02 - isSpec - isLP - isMin'
    },
    {
      num: '27.3',
      link: 'platby-nahrady-vydaju-inspekce-distribuce',
      name: 'Náhrady výdajů - Inspekce, distribuce',
      info: 'default - 03 - isSpec - noLP - isMin'
    },
    {
      num: '27.4',
      link: 'platby-nahrady-vydaju-lidske-tkane-a-bunky',
      name: 'Náhrady výdajů - Lidské tkáně a buňky',
      info: 'default - 20 - noSpec - noLP - noMin'
    },
    {
      num: '27.5',
      link: 'platby-nahrady-vydaju-lekarny-prodejci',
      name: 'Náhrady výdajů - Lékárny, prodejci, laboratorní rozbor, propouštění šarží',
      info: 'default - 04 - isSpec - noLP - isMin'
    },
    {
      num: '27.6',
      link: 'platby-nahrady-vydaju-obecne-vcetne-reklamy',
      name: 'Náhrady výdajů - Obecné včetně reklamy na léčivé přípravky',
      info: 'default - 01 - isSpec - noLP - isMin'
    },
    {
      num: '27.7',
      link: 'platby-nahrady-vydaju-klinicke-hodnoceni',
      name: 'Náhrady výdajů - Klinické hodnocení, léčebné programy, rozlišování léčiv od jiných výrobků',
      info: 'default - 05 - isSpec - noLP - isMin | | requiredIc - hasMobil'
    },
    {
      num: '27.8',
      link: 'platby-nahrady-vydaju-rocni-udrzovaci-platba',
      name: 'Náhrady výdajů - Roční udržovací platba',
      info: 'custom - 14'
    },
    {
      num: '27.9',
      link: 'platby-spravni-poplatky-registrace',
      name: 'Správní poplatky - Registrace',
      info: 'default - 09 - noSpec - isLP - noMin'
    },
    {
      num: '27.10',
      link: 'platby-spravni-poplatky-vyroba-ltb',
      name: 'Správní poplatky - Výroba, LTB',
      info: 'default - 10 - noSpec - noLP - noMin'
    },
    {
      num: '27.11',
      link: 'platby-spravni-poplatky-distribuce',
      name: 'Správní poplatky - Distribuce',
      info: 'default - 11 - noSpec - noLP - noMin'
    },
    {
      num: '27.12',
      link: 'platby-spravni-poplatky-ceny-a-uhrady',
      name: 'Správní poplatky - Ceny a úhrady',
      info: 'custom - 15'
    },
    {
      num: '27.13',
      link: 'platby-spravni-poplatky-lecebne-konopi',
      name: 'Správní poplatky - Státní agentura pro léčebné konopí',
      info: 'default - 18 - noSpec - noLP - noMin'
    },
    {
      num: '27.14',
      link: 'platby-spravni-poplatky-vydani-stejnopisu-opisu-kopie',
      name: 'Správní poplatky - Vydání stejnopisu, opisu, kopie, fotokopie nebo výpisu',
      info: 'default - 12 - noSpec - noLP - noMin'
    },
    {
      num: '27.15',
      link: 'platby-spravni-poplatky-zadost-o-poseckani-s-platbou',
      name: 'Správní poplatky - Žádost o posečkání s platbou pokuty nebo o rozložení platby do splátek',
      info: 'default - 19 - noSpec - noLP - noMin | | requiredIc - hasDatovka - isSpisova'
    },
    {
      num: '27.16',
      link: 'platby-pokuty',
      name: 'Pokuty',
      info: 'custom - 16'
    },
    {
      num: '27.17',
      link: 'platby-nahrady-vydaju-ceny-a-uhrady',
      name: 'Náhrady výdajů - Ceny a úhrady',
      info: 'custom - 23'
    },
    {
      num: '27.18',
      link: 'platby-nahrady-vydaju-lecebne-konopi',
      name: 'Náhrady výdajů - Státní agentura pro léčebné konopí',
      info: 'default - 24 - noSpec - noLP - noMin'
    },
    {
      num: '35',
      link: 'kontaktni-formular',
      name: 'Kontaktní formulář'
    },
  ],
  'E4': [
    {
      num: '32',
      link: 'hlaseni-podezreni-na-vyskyt-padelku-lp',
      name: '#9153 Hlášení podezření na výskyt padělku LP',
      dbid: 'ce196c58-be6e-4aee-a58e-ce1761d1cb5d'
    },
    {
      num: '33',
      link: 'hlaseni-podezreni-na-zavadu-lp',
      name: '#9154 Hlášení podezření na závadu v jakosti LP',
      dbid: 'ae3a47db-7419-4995-9b2c-fa032a4b4470'
    },
    {
      num: '20',
      link: 'zadost-o-souhlas-s-dovozem-leciveho-pripravku-ze-treti-zeme',
      name: 'AB896 - Žádost o souhlas s dovozem LP ze třetí země',
      dbid: 'f46790ad-82af-475b-9579-8f73203a5322'
    },
    {
      num: '34',
      link: 'zadost-o-umozneni-uvedeni-cizojazycne-sarze-leciveho-pripravku-do-obehu',
      name: 'AB893 - Žádost o umožnění uvedení cizojazyčné šarže LP do oběhu  (suklkod 1658, 25699)',
      dbid: '8c618f8d-2f4a-4176-850e-02735a517f22'
    },
    {
      num: '36',
      link: 'hlaseni-nelegalni-nabidky-leciveho-pripravku',
      name: 'AB8228 - Hlášení nelegální nabídky léčivého přípravku',
      dbid: ''
    }
  ],
  'E5': [
    {
      num: '37',
      link: 'zadost-nekategorizovane-potraviny-pro-zvlastni-lekarske-ucely',
      name: '#11132 Žádost o stanovení/změnu/zrušení maximální ceny výrobce a výše a podmínek úhrady nekategorizované potraviny pro zvláštní lékařské účely',
      dbid: 'ca199753-3461-4da1-95ff-7a63022631b2'
    },{
      num: '41',
      link: 'zadost-o-zhodnoceni-nemocnicnich-lecivych-pripravku',
      name: '#11356 Žádost o hodnocení přínosů a nákladů u léčivých přípravků, které lze používat pouze při lůžkové péči',
      dbid: 'a9598980-55e4-4109-94b5-9e88f4c7c86f'
    },{
      num: '38',
      link: 'ohlaseni-pzlu-uhradova-skupina',
      name: '#11567 Ohlášení pro zařazení/změnu zařazení/vyřazení potraviny pro zvláštní lékařské účely do úhradové skupiny',
      dbid: 'cf130ebd-f573-4573-844d-ef6ca13d1c69'
    },{
      num: '39',
      link: 'ohlaseni-zmeny-udaju-kategorizovane-pzlu',
      name: '#11573 Ohlášení změny údajů kategorizované potraviny pro zvláštní lékařské účely',
      dbid: '66421eca-13f8-4718-885b-d8c0b11f530b'
    },{
      num: '40',
      link: 'ohlaseni-zmeny-ceny-kategorizovane-pzlu',
      name: '#11596 Ohlášení změny oznámené ceny kategorizované potraviny',
      dbid: '4a98c1ff-cedf-4673-b8ef-e09cb21e2ffb'
    },
  ]
}

const DB_URL_EDIT = 'https://adminer.dev.eforms.qcm.cz/?pgsql=postgres&username=postgres&db=eforms-server&ns=public&edit=form_schemas&where%5Bid%5D='

const FormList = () => {

  if (!DEMO) {
    return null
  }
  return (
    <>
      {Object.entries(etaps).map(([title, forms]) =>
        <>
          <h2>{title}</h2>
          <table cellPadding={3}>

            {forms.map(({ name, link, num, link2, dbid, info }) =>
              <tr>
                <td>

                  <a href={'/form/' + link} target="_blank" rel="noopener noreferrer">
                    {num} - {name || link}
                  </a>
                </td>

                <td>
                  {dbid &&
                    <a href={DB_URL_EDIT + dbid} target="_blank" rel="noopener noreferrer">
                      DB
                    </a>
                  }
                </td>

                <td>
                  <small>
                    {info}
                  </small>
                </td>

                <td>
                  {link2 &&
                    <a href={link2}>
                      {' '} + {link2}
                    </a>
                  }
                </td>
              </tr>
            )}
          </table>

          <br/>
          <br/>
          <br/>
        </>
      )}
    </>
  )
}

export default FormList
